import { render } from "./Batches.vue?vue&type=template&id=6107cb94&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"

import "./Batches.vue?vue&type=style&index=0&id=6107cb94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6107cb94"]])

export default __exports__